import { ComponentProps, forwardRef } from 'react'
import { webchatClasses } from '../../styles/classes'

export const Fab = forwardRef<HTMLDivElement, ComponentProps<'div'> & { imgUrl?: string }>(
  ({ children, onClick, imgUrl, ...props }, ref) => {
    const { fab } = webchatClasses
    const { container, icon, image } = fab ?? {}

    return imgUrl ? (
      <img src={imgUrl} role="button" tabIndex={0} {...image} draggable="false" onClick={onClick} />
    ) : (
      <div {...props} {...container} ref={ref} onClick={onClick}>
        <div {...icon} />
      </div>
    )
  }
)

Fab.displayName = 'Fab'
